import { useRouter } from "src/hooks/useRouter";
import notFoundImage from "src/assets/images/illust/404.svg";
import "./index.style.scss";
import { useTranslation } from "react-i18next";
const NotFoundPage = () => {
  const route = useRouter();
  const { t } = useTranslation();
  return (
    <div className="error">
      <h3 className="error__title">{t("error.notFoundPage.title")}</h3>
      {t("error.notFoundPage.subTitle")
        .split("\n")
        .map((i: string, index: number) => (
          <p className="error__desc" key={index}>
            {i}
          </p>
        ))}
      <div className="errorApply">
        {/* <div className="image"> */}
        <img src={notFoundImage} alt="notFoundImage" />
        {/* </div> */}
      </div>
      <div className="goToButton">
        <button
          type="button"
          style={{
            background: "rgba(49, 130, 246, 1)",
            border: "none",
            borderRadius: "8px",
            fontWeight: "500",
            color: "white",
          }}
          onClick={route.goLogin}
        >
          {t("common.goBackBtn")}
          {/* {t(
            "error.notFoundPage.goToMainBtn." + getProductInfo().key
          )} */}
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
